import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { FilterCriteriaEDT } from 'app/models/FilterCriteriaEDT';
import { FilterCriteriaListEdt } from 'app/models/FilterCriteriaListEdt';
import { KioskListResource } from 'app/models/KioskListResource';
import { KioskResource } from 'app/models/KioskResource';
import { UtilsService } from 'app/services/utils.service';
import { UserListService } from 'app/user/user-list/user-list.service';
import { forkJoin, Timestamp } from 'rxjs';
import { isNull } from 'util';

@Component({
	selector: 'vbn-kiosk',
	templateUrl: './kiosk.component.html',
	styleUrls: ['./kiosk.component.scss'],
	providers: [UserListService],
})
export class KioskComponent implements OnInit {

	isLoading: boolean = false;
	kiosksList: KioskListResource;
	errorMessage: string;
	isAscSerialNo: boolean = false;
	isAscCompanyName: boolean = false;
	isAscUserEmail: boolean = false;
	isAscLocation: boolean = false;
	filterCriteria: FilterCriteriaListEdt;
	sorted: FilterCriteriaEDT;
	kiosk: {
		serialNo: string;
		companyName: string;
		userEmail: string;
		// location: string;
		nameRo: string;
		nameEn: string;
		nameFr: string;
		nameDe: string;
	};
	roleId: number;
	userEmail: string;
	column: string = '';
	isClient = false;
	currentLanguage = localStorage.getItem("vbn-language");
	isAscNameRo: boolean = false;
	isAscNameEn: boolean = false;
	isAscNameFr: boolean = false;
	isAscNameDe: boolean = false;
	isOnResponsive: boolean = false;

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		const innerWidth = window.innerWidth;
		if (innerWidth <= 1420) {
			this.isOnResponsive = true;
		}
		else {
			this.isOnResponsive = false;
		}
	}

	constructor(private userListService: UserListService,
		private router: Router,
		private _notificationService: NotificationsService,
		private translate: TranslateService,
		private service: UtilsService) {

		this.kiosksList = new KioskListResource();
		this.kiosksList.list = [];
		this.filterCriteria = new FilterCriteriaListEdt();
		this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
		this.sorted = new FilterCriteriaEDT();
		this.kiosk = {
			serialNo: null,
			companyName: null,
			userEmail: null,
			//location: null
			nameRo: null,
			nameEn: null,
			nameFr: null,
			nameDe: null
		};


	}

	ngOnInit() {
		this.roleId = parseInt(localStorage.getItem("_roleId"));
		if (this.roleId === 2) {
			this.isClient = true;
		}
		this.userEmail = atob(localStorage.getItem("_user")); // unly the logged user Admin or BPO
		this.getKiosksList(null);
		if (innerWidth <= 1420) {
			this.isOnResponsive = true;
		}
		else {
			this.isOnResponsive = false;
		}
	}

	getKiosksList(property) {
		this.column = ((this.column === '' || this.column === 'any' || this.column !== property) && !isNull(property)) ? property : this.column;
		if (this.column == 'serialNo') {
			//if property == null then the user clicked on another page
			this.isAscSerialNo = (isNull(property)) ? this.isAscSerialNo : !this.isAscSerialNo;
			this.sorted.type = "orderBy";
			this.sorted.value = (this.isAscSerialNo) ? "asc" : "desc";
			this.sorted.field = "serialNo";
		}
		if (this.column == 'companyName') {
			//if property == null then the user clicked on another page
			this.isAscCompanyName = (isNull(property)) ? this.isAscCompanyName : !this.isAscCompanyName;
			this.sorted.type = "orderBy";
			this.sorted.value = (this.isAscCompanyName) ? "asc" : "desc";
			this.sorted.field = "companyName";
		}
		if (this.column == 'nameRo') {
			//if property == null then the user clicked on another page
			this.isAscNameRo = (isNull(property)) ? this.isAscNameRo : !this.isAscNameRo;
			this.sorted.type = "orderBy";
			this.sorted.value = (this.isAscNameRo) ? "asc" : "desc";
			this.sorted.field = "nameRo";
		}
		if (this.column == 'nameEn') {
			//if property == null then the user clicked on another page
			this.isAscNameEn = (isNull(property)) ? this.isAscNameEn : !this.isAscNameEn;
			this.sorted.type = "orderBy";
			this.sorted.value = (this.isAscNameEn) ? "asc" : "desc";
			this.sorted.field = "nameEn";
		}
		if (this.column == 'nameFr') {
			//if property == null then the user clicked on another page
			this.isAscNameFr = (isNull(property)) ? this.isAscNameFr : !this.isAscNameFr;
			this.sorted.type = "orderBy";
			this.sorted.value = (this.isAscNameFr) ? "asc" : "desc";
			this.sorted.field = "nameFr";
		}
		if (this.column == 'nameDe') {
			//if property == null then the user clicked on another page
			this.isAscNameDe = (isNull(property)) ? this.isAscNameDe : !this.isAscNameDe;
			this.sorted.type = "orderBy";
			this.sorted.value = (this.isAscNameDe) ? "asc" : "desc";
			this.sorted.field = "nameDe";
		}
		if (this.column == 'userEmail') {
			//if property == null then the user clicked on another page
			this.isAscUserEmail = (isNull(property)) ? this.isAscUserEmail : !this.isAscUserEmail;
			this.sorted.type = "orderBy";
			this.sorted.value = (this.isAscUserEmail) ? "asc" : "desc";
			this.sorted.field = "userEmail";
		}
		// 	if (this.column == 'location') {
		// 		//if property == null then the user clicked on another page
		// 		this.isAscLocation = (isNull(property)) ? this.isAscLocation : !this.isAscLocation;
		// 		this.sorted.type = "orderBy";
		// 		this.sorted.value = (this.isAscLocation) ? "asc" : "desc";
		// 		this.sorted.field = "location";
		// }

		if (this.column != "") {
			for (let i = 0; i < this.filterCriteria.filters.length; i++) {
				if (this.filterCriteria.filters[i].type == "orderBy") {
					let index = this.filterCriteria.filters.indexOf(this.sorted);
					this.filterCriteria.filters.splice(index, 1);
				}
			}
			this.filterCriteria.filters.push(this.sorted);
		}

		this.isLoading = true;
		this.userListService.post('/admin/kiosk/getAll?userEmail=' + this.userEmail, this.filterCriteria)
			.subscribe(
				response => {
					this.kiosksList = response;
					if (this.kiosksList.errorCode == 1002) {
						forkJoin(
							[this.translate.get('Error'),
							this.translate.get('0 items found after the search!')]
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'error')
						});
						this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
						this.kiosksList = new KioskListResource();
						this.kiosksList.list = [];
					}
					this.isLoading = false;
				},
				error => {
					this.isLoading = false;
					this.errorMessage = <any>error
				});
	}

	goToEdit(id: string) {
		window.scrollTo(500, 0);
		this.router.navigate(['/edit-kiosk/' + btoa('{ "kioskRid" : "' + id + '"}')]);
	}

	deleteKiosk(id: string) {
		this.userListService.get('/admin/kiosk/delete/' + id + "?userEmail=" + this.userEmail)
			.subscribe(
				response => {
					this.getKiosksList(null);
				},
				error => this.errorMessage = <any>error);
	}

	applyFilter() {
		this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
		Object.getOwnPropertyNames(this.kiosk).forEach(x => {
			if (this.kiosk == null || this.kiosk[x] == undefined || this.kiosk[x] === "") {
				delete this.kiosk[x];
				return;
			}
			var item = new FilterCriteriaEDT();
			item = {
				field: x,
				value: this.kiosk[x],
				type: "" + typeof this.kiosk[x]
			}
			if (item.value != null && item.value != undefined) {
				this.filterCriteria.filters.push(item);
			}
		})
		this.getKiosksList(null);
	}

	resetFilter() {
		this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
		this.kiosk = {
			serialNo: null,
			companyName: null,
			userEmail: null,
			//location: null
			nameRo: null,
			nameEn: null,
			nameFr: null,
			nameDe: null
		};
		this.getKiosksList(null);
	}

	showResponsiveDetails(kioskId) {
		const width = window.innerWidth;
		if (width <= 1420) {
			for (let i = 0; i < this.kiosksList.list.length; i++) {
				if (this.kiosksList.list[i].rid == kioskId) {
					this.kiosksList.list[i].showDetailsOnResponsive = !this.kiosksList.list[i].showDetailsOnResponsive;
				}
				else {
					this.kiosksList.list[i].showDetailsOnResponsive = false;
				}
			}
		}
		else {
			return;
		}

	}
}
